// hooks/useLogout.js
import { useNavigate } from 'react-router-dom';
import { useStudentAuth } from '../context/StudentAuthContext';
import {clearStudentCookies, clearLocalStorage, cancelPendingRequests, broadcastLogout, forceLocalLogout, showSuccessMessage} from '../utils/helper/cookieUtils'


export const useLogout = () => {
    const { studentLogout: contextLogout } = useStudentAuth();
    const navigate = useNavigate();

    const logout = async () => {
        try {
            // 1. Start logout process
            await contextLogout();
            
            // 2. Clear all student-specific cookies
            clearStudentCookies();
            
            // 3. Clear all localStorage/sessionStorage
            clearLocalStorage();
            
            // 4. Broadcast logout to other tabs
            broadcastLogout();
            
            // 5. Cancel pending requests
            cancelPendingRequests();
            
            // 6. Navigate with SPA routing (no page reload)
            navigate('/students-login', {
                replace: true, // Prevent back button issues
                state: { 
                    logout: true,
                    timestamp: Date.now()
                }
            });
            
            // 7. Show user feedback
            showSuccessMessage();
            
        } catch (error) {
            console.error('Logout failed:', error);
            // Even if API fails, ensure local logout
            forceLocalLogout();
        }
    };

    return { logout };
};